import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from '../components/footer'
import aboutBG from '../assets/about-bg.jpg'
// import teamPic from '../assets/team.jpg'
import Amit from '../assets/amit.jpg'
import Savarmal from '../assets/savarmal.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserAlt } from '@fortawesome/free-solid-svg-icons';
import Teambg from '../assets/teambg.png'
import Numbers from '../components/numbers'
import adapt from '../assets/adapt.jpg'

class About extends React.Component{
    render(){
        const TeamBG = {
            backgroundImage: `URL(${Teambg})`,
            backgroundRepeat: 'repeat'
        }
        return(
            <div>
                <Helmet>
                    <title>Amit Paintings - About us</title>
                </Helmet>
                <section className="md:px-10 px-2 py-2 md:py-10 bg-white">
                    <div className="grid grid-cols-12 gap-6">
                        <div className="col-span-12 md:col-span-6">
                            <img alt="Amit Paintings" src={aboutBG} className="rounded-lg shadow-lg border-white border-solid border-8" />
                        </div>
                        <div className="col-span-12 md:col-span-6">
                            <h5 className="uppercase font-semibold text-ap"><FontAwesomeIcon icon={faUserAlt} /> About us</h5>
                            <hr className="border-pink-600 border-2 my-3 w-2/12" />
                            <h1 className="text-3xl font-bold leading-tight mb-5">Bringing Imagination to surface, Quality Products at Quality Prices, Customer satisfaction is what we prefer</h1>
                            <p className="leading-loose">The company has come a long way since its beginning back in 1986 starting from laying of tiles, granites and stones in Mumbai and then in Nasik. After being successful in flooring work, a step towards further integration was taken as paint applicators. Company reflects the spirit of its chairman Director Mr. Savarmal Saini who has refined a brand in market since 2003. From past few years Mr. Saini is listed as one of the premium applicators by Berger paints and Asian paints in Telangana.</p>
                        </div>
                    </div>
                </section>
                <section className="md:px-10 px-2 py-10 ">
                    <Numbers />
                </section>

                <section className="md:px-10 px-2 md:pb-10 py-10" style={TeamBG}>
                    <div className="grid grid-cols-12 pb-10 gap-4">
                        <div className="col-span-12">
                            <h2 className="text-center text-3xl font-bold uppercase text-as">Management</h2>
                            <hr className="border-pink-600 border-4 w-1/4 mx-auto my-3" />
                        </div>
                        <div className="col-span-12 md:col-span-3 md:col-start-4">
                            <div className="border-8 border-white bg-white text-center rounded-lg shadow">
                                <img src={Savarmal} alt="Savarmal" />
                                <div className="p-3">
                                    <p className="text-xs font-semibold Capitalize">Founder & Chaiman</p>
                                    <p className="text-xl font-bold uppercase tracking-tight">Savarmal Saini</p>
                                    <p className="text-sm text-pink-600">Nidhi Infra, Amit Paintings</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-3">
                            <div className="border-8 border-white bg-white text-center rounded-lg shadow">
                                <img src={Amit} alt="Savarmal" />
                                <div className="p-3">
                                    <p className="text-xs font-semibold Capitalize">CEO</p>
                                    <p className="text-xl font-bold uppercase tracking-tight">Amit Saini</p>
                                    <p className="text-sm text-pink-600">Amit Paintings</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="md:px-10 px-2 py-10 ">
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12">
                            <h2 className="text-2xl mx-auto text-center font-bold uppercase">Certified ADAPT(2016)</h2>
                            <h3 className="text-sm uppercase tracking-loose font-bold mb-5 text-center text-ap">By Asian Paints</h3>

                            <img src={adapt} className="mx-auto border-8 border-white shadow rounded-lg" />
                        </div>
                    </div>
                </section>

                <Footer/>
            </div>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/about.jsx